import {
  isDevRuntime,
  isStagingRuntime,
  isTestRuntime,
} from '../../common/utils';

export const isDevelopmentEnvironment = (
  hostname: string | undefined
): boolean => {
  return hostname ? hostname.includes('.local.yle.fi') : false;
};

export const getAppEnv = () => {
  if (isTestRuntime()) {
    return 'test';
  }
  if (isDevRuntime()) {
    return 'dev';
  }
  if (isStagingRuntime()) {
    return 'staging';
  }
  return 'production';
};
